import React, { useState } from "react";
import { Box, Card, Grid, Stack, Typography, } from "@mui/material";
import Highcharts, { color } from "highcharts";
import HighchartsReact from "highcharts-react-official";
import TitleBar from "components/TitleBar";




const usedColors = new Set();


const colorPalette = ["#62B6CB", "#5FA8D3"];


const HseTrainingConducted = ({ data }) => {
    const [isView, setIsView] = useState(false);
    const [rowData, setRowData] = useState(null);

    const barData = [
        {
            name: "HSE Training conducted",
            y: data?.training?.hseTrainingConducted || 0
        },
        {
            name: "Tool Box Talk Training conducted",
            y: data?.training?.toolBoxTalkTrainingConducted || 0
        }
    ];


    const chartData = barData.map((item, index) => ({
        y: item.y,
        name: item.name,
        color: colorPalette[index],
    }));


    const total = barData.reduce((sum, item) => sum + item.y, 0);


    const handleGetRisk = (point) => {
        setIsView((prev) => {
            const newState = !prev;
            setRowData(newState ? { Ageing: point } : null);
            return newState;
        });
    };

    const handleClose = () => {
        setIsView(false);
        setRowData(null);
    };


    const options = {

        chart: {
            type: 'column'
        },
        title: {
            text: ''
        },
        subtitle: {
            text: ''
        },
        xAxis: {
            type: 'category',
            labels: {
                style: {
                    color: "#6B7280",
                    textOutline: 'none',
                    fontSize: "12px",
                    fontWeight: 600,
                }
            }
        },
        yAxis: {
            min: 0,
            title: {
                text: 'Total HSE Training',
                style: {
                    fontSize: "13px",
                    fontWeight: 600,
                    color: "#182A4E",
                    fontFamily: "Outfit, sans-serif",
                }
            }
        },
        plotOptions: {
            column: {
                dataLabels: {
                    enabled: true,
                    format: '{point.y}',
                    style: {
                        fontSize: '12px',
                        fontWeight: 'bold',
                        color: '#000',
                        textOutline: 'none'
                    }
                }
            }
        },
        legend: {
            enabled: false
        },
        tooltip: {
            pointFormat: '{point.name}: <b>{point.y}</b>'
        },
        series: [{
            name: 'Hse Traing',
            data: chartData
        }],
        credits: {
            enabled: false,
        },
    };

    return (
        <Card sx={{
            background: "#fff",
            borderRadius: 1,
            padding: 0,
            boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.05)",
            border: "1px solid #E4E4E4",
            height: "100%"
        }}>
            <Grid size={12}>
                <TitleBar title={"HSE Training"} description={""} />
            </Grid>


            {total === 0 ? (
                <Typography
                    sx={{
                        textAlign: "center",
                        padding: "40px",
                        color: "#9CA3AF",
                        fontSize: "14px",
                        fontWeight: 500
                    }}
                >
                    No Data Available
                </Typography>
            ) : (
                <HighchartsReact highcharts={Highcharts} options={options} />
            )}

        </Card>
    );
};

export default HseTrainingConducted;